export default __webpack_public_path__ + "static/media/yx1.43d3d5cf.png";